/**
 * 组件使用场景：发起争议处理
 * 组件使用 -> API:dispatch.initiateDispute.show(id) 展开model => id为逻辑必需值
 * API使用 ->
 * API:import { showInitiateDispute } from '@/shared/utils';
 * showInitiateDispute(id) 展开model => id为逻辑必需值
 *
 * */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Form, Input, Select, message } from 'antd';
import { Provider, connect } from '@souche-f2e/muji';
import store, { dispatch } from '@@/store';
const mapStateToProps = (rootState) => ({ initiateDispute: rootState.initiateDispute });
class InitiateDisputeComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 0,
        };
        this.ok = this.ok.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.cancel = this.cancel.bind(this);
        this.afterClose = this.afterClose.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.getFormItemOperate = this.getFormItemOperate.bind(this);
        this.disputeTypeChange = this.disputeTypeChange.bind(this);
        this.openTypeChange = this.openTypeChange.bind(this);
        this.handleChangeText = this.handleChangeText.bind(this);
        this.onhandleCancel = this.onhandleCancel.bind(this);
    }
    componentDidMount() {
        dispatch.initiateDispute.getOpenType({});
    }
    cancel() {
        const props = this.props;
        if (props.initiateDispute.confirmLoading) {
            message.warning('正在发起争议中，请稍后再试');
        }
        else {
            dispatch.initiateDispute.hide();
        }
        dispatch.initiateDispute.resetState();
    }
    afterClose() {
        dispatch.initiateDispute.resetState();
        this.resetForm();
    }
    onhandleCancel() {
        const props = this.props;
        if (props.initiateDispute.confirmLoading) {
            message.warning('正在发起争议中，请稍后再试');
        }
        else {
            dispatch.initiateDispute.hide();
            this.resetForm();
            dispatch.initiateDispute.resetState();
            this.setState({
                count: 0,
            });
        }
    }
    ok() {
        const props = this.props;
        dispatch.initiateDispute.confirmDispute(props.form);
        // dispatch.atAuction.updateTable({});
    }
    // 重置选择框
    resetForm(resetList) {
        const props = this.props;
        props.form.resetFields(resetList);
    }
    // 发起方类型改变
    openTypeChange(val, option) {
        dispatch.initiateDispute.changeOpenType(val);
        this.resetForm(['disputeType', 'disputeChildType']);
    }
    handleOk() {
        const props = this.props;
        dispatch.initiateDispute.confirmDisputeDeal(props.form);
        dispatch.initiateDispute.SET_STATE({
            actionType: '',
            orderTag: '',
        });
    }
    // 争议类型改变
    disputeTypeChange(val, option) {
        dispatch.initiateDispute.changeDisputeType(val).then(() => {
            dispatch.initiateDispute.getDisputeChildType({});
            this.resetForm(['disputeChildType']);
        });
    }
    // 争议子类型
    disputeChildTypeChange(val, option) {
        dispatch.initiateDispute.changeDisputeChildType(val);
    }
    getFormItemOperate() {
        return (<div style={{ display: 'inline-block' }}>
        <span>争议子类型</span>
        <span style={{
            color: '#3C8EE9',
            marginLeft: '15px',
            cursor: 'pointer',
        }} onClick={() => {
            dispatch.initiateDispute.goDisputeChildType({});
        }}>
          设置
        </span>
      </div>);
    }
    handleChangeText(e) {
        const count = e.target.value.length;
        this.setState({
            count,
        });
    }
    render1() {
        const props = this.props;
        const { getFieldDecorator } = props.form;
        const { visibles } = props.initiateDispute;
        return (<div>
        <Modal centered title="发起争议处理" okText="确认" onOk={this.handleOk} cancelText="取消" onCancel={this.onhandleCancel} visible={visibles}>
          <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} labelAlign="right">
            <Form.Item label="扣除金额">
              <span className="ant-form-text">2000元</span>
            </Form.Item>
            <Form.Item label="处理类型">
              {getFieldDecorator('dealType', {
            rules: [
                {
                    required: true,
                },
                {
                // validator: true
                },
            ],
            initialValue: '卖家违约',
        })(<Input disabled={true}/>)}
            </Form.Item>
            <Form.Item colon={false} label="备注">
              {getFieldDecorator('disputeReason', {
            rules: [
                {
                    required: true,
                    message: '请输入申诉内容',
                },
                {
                    max: 100,
                    message: '限100字',
                },
            ],
        })(<Input.TextArea placeholder="请输入申诉内容" autoSize={{
            minRows: 6,
            maxRows: 8,
        }} maxLength={100} onChange={this.handleChangeText}/>)}
              <span style={{ position: 'absolute', top: -15, right: 7 }}>
                {this.state.count}/100
              </span>
            </Form.Item>
          </Form>
        </Modal>
      </div>);
    }
    render2() {
        const props = this.props;
        const { getFieldDecorator } = props.form;
        const { openType, visible, disputeType, disputeChildType, openVal, confirmLoading, } = props.initiateDispute;
        return (<Modal centered title="发起争议处理" okText="确认" onOk={this.ok} cancelText="取消" onCancel={this.cancel} visible={visible} afterClose={this.afterClose} confirmLoading={confirmLoading}>
        <Form layout="vertical">
          <Form.Item colon={false} label="争议发起">
            {getFieldDecorator('openType', {
            rules: [
                {
                    required: true,
                    message: '请选择争议发起',
                },
            ],
        })(<Select placeholder="请选择争议发起" style={{ width: 300 }} notFoundContent="暂无数据" onChange={this.openTypeChange}>
                {openType.map((v, i) => (<Select.Option value={v.code} key={`open-${v.name}-${v.code}`}>{v.name}</Select.Option>))}
              </Select>)}
          </Form.Item>
          <Form.Item colon={false} label="争议类型">
            {getFieldDecorator('disputeType', {
            rules: [
                {
                    required: true,
                    message: '请选择争议类型',
                },
            ],
        })(<Select placeholder="请选择争议类型" style={{ width: 300 }} notFoundContent={(openVal === '') ? '请先选择争议发起' : '暂无数据'} onChange={this.disputeTypeChange}>
                {disputeType.map((v, i) => (<Select.Option value={v.code} key={`dispute-${v.name}-${v.code}`}>{v.name}</Select.Option>))}
              </Select>)}
          </Form.Item>
          <Form.Item colon={false} label={this.getFormItemOperate()}>
            {getFieldDecorator('disputeChildType', {
            rules: [],
        })(<Select placeholder="请选择争议子类型" style={{ width: 300 }} notFoundContent="暂无数据" onChange={this.disputeChildTypeChange}>
                {disputeChildType.map((v, i) => (<Select.Option value={v.id} key={`dispute-child-${v.childTypeName}-${v.id}`}>
                      {v.childTypeName}
                    </Select.Option>))}
              </Select>)}
          </Form.Item>
          <Form.Item colon={false} label="争议原因">
            {getFieldDecorator('disputeReason', {
            rules: [
                {
                    required: true,
                    message: '请填写争议原因',
                },
                {
                    max: 50,
                    message: '限50字',
                },
            ],
        })(<Input.TextArea placeholder="请填写争议原因" autoSize={{
            minRows: 4,
            maxRows: 4,
        }}/>)}
          </Form.Item>
        </Form>
      </Modal>);
    }
    render() {
        const props = this.props;
        // const { actionType, orderTag } = props.initiateDispute;
        return (<div>
        {this.render2()}
      </div>);
    }
}
InitiateDisputeComponent.defaultProps = {};
const InitiateDisputeFrom = Form.create({})(InitiateDisputeComponent);
const InitiateDispute = connect(mapStateToProps, null, null, { forwardRef: true })(InitiateDisputeFrom);
export default InitiateDispute;
/**
 * API
 * */
let componentRef = '';
const createInitiateDispute = () => {
    const div = document.createElement('div');
    div.className = 'souche-initiate-discupt';
    document.body.appendChild(div);
    // @ts-ignore
    const component = (
    // @ts-ignore
    <Provider store={store}>
      {React.createElement(InitiateDispute, {
        // @ts-ignore
        ref: (ref) => {
            componentRef = ref;
        },
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
export function showInitiateDispute({ data, lubanType, callback }) {
    if (!componentRef) {
        createInitiateDispute();
    }
    dispatch.initiateDispute.show({ data, lubanType, callback });
}
